import { render, staticRenderFns } from "./ConnectionAssignments.vue?vue&type=template&id=1381c5f8&scoped=true"
import script from "./ConnectionAssignments.vue?vue&type=script&lang=ts"
export * from "./ConnectionAssignments.vue?vue&type=script&lang=ts"
import style0 from "./ConnectionAssignments.vue?vue&type=style&index=0&id=1381c5f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1381c5f8",
  null
  
)

export default component.exports